export default __webpack_public_path__ + "static/devesecops-support3-c2fa37ad3ccb5e5546bc51ac55c6a33d.jpg";